import { AccommodationOffer } from "~/applications/OfferSearch/Domain/AccommodationOffer";
import { OfferPrices } from "~/applications/OfferSearch/Domain/OfferPrices";
import { UnitGroup } from "~/applications/OfferSearch/Domain/UnitGroup";

export class Offer {
  constructor(
    private readonly accommodationOffer: AccommodationOffer,
    public readonly unitGroup: UnitGroup,
  ) {
    if (accommodationOffer.unitGroupId !== unitGroup.id) {
      throw new Error(
        `You could not build an offer with an accommodation offer and a unit group that does not match. ${JSON.stringify(
          {
            accommodationOffer: { unitGroupId: accommodationOffer.unitGroupId },
            unitGroup: { id: unitGroup.id },
          },
        )}`,
      );
    }
  }

  public prices(): OfferPrices {
    return this.accommodationOffer.basePrices;
  }

  public isSoldOut(): boolean {
    return this.accommodationOffer.isSoldOut;
  }
}
